import { render, staticRenderFns } from "./JobCard.vue?vue&type=template&id=4ed59ff9&scoped=true"
import script from "./JobCard.vue?vue&type=script&lang=js"
export * from "./JobCard.vue?vue&type=script&lang=js"
import style0 from "./JobCard.vue?vue&type=style&index=0&id=4ed59ff9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed59ff9",
  null
  
)

export default component.exports